import { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { useAccountById, useAccountStatusDefinitions, useAccountStatusReasons } from '@app/sdk';
import { AccountStatusForm } from './AccountStatusForm';
import { SelectOption } from '../../../shared/forms';

export function AccountStatus() {
  const { accountId } = useContext(AccountContext);

  const [chargeOffReasonOptions, setChargeOffReasonOptions] = useState<SelectOption[]>([]);
  const [closureReasonsOptions, setClosureReasonsOptions] = useState<SelectOption[]>([]);
  const [accountStatusOptions, setAccountStatusOptions] = useState<SelectOption[]>([]);
  const { data: account } = useAccountById(accountId);
  const { data: accountStatusDefinitions } = useAccountStatusDefinitions();
  const { data: chargeOffReasonsResponse } = useAccountStatusReasons('ChargeOff');
  const { data: closureReasonsResponse } = useAccountStatusReasons('AccountClosedPayDown');
  
  useEffect(() => {
    if (accountStatusDefinitions && accountStatusDefinitions.length >= 0) {
      setAccountStatusOptions(accountStatusDefinitions.map((status) => {
        return {
          label: status.name,
          value: status.id
        }
      }));
    }
  }, [accountStatusDefinitions]);

  useEffect(() => {
    if (chargeOffReasonsResponse && chargeOffReasonsResponse.accountStatusReasons.length >= 0) {
      setChargeOffReasonOptions(chargeOffReasonsResponse.accountStatusReasons.map((reason) => {
        return {
          label: reason.reason,
          value: reason.reason
        }
      }));
    }
  }, [chargeOffReasonsResponse]);

  useEffect(() => {
    if (closureReasonsResponse && closureReasonsResponse.accountStatusReasons.length >= 0) {
      setClosureReasonsOptions(closureReasonsResponse.accountStatusReasons.map((reason) => {
        return {
          label: reason.reason,
          value: reason.reason
        }
      }));
    }
  }, [closureReasonsResponse]);
  
  return (
    <div className="ui segment">
      <div className="ui header">Status: {account?.accountStatus?.name}</div>
      {account?.accountStatus?.accountStatusUpdateReason && (
          <div className="ui header">Reason: {account.accountStatus.accountStatusUpdateReason}</div>
      )}
      <div className="content">
        {accountStatusOptions && account?.accountStatus?.id && (
          <AccountStatusForm
            currentStatusID={account?.accountStatus?.id}
            accountStatuses={accountStatusOptions}
            chargeOffReasons={chargeOffReasonOptions}
            closureReasons={closureReasonsOptions}
          />
        )}
      </div>
    </div>
  );
}
